// extracted by mini-css-extract-plugin
export default {"cardd":"style_cardd__YKywk","btnn":"style_btnn__g5JiD","t":"style_t__Pe5PS","s":"style_s__byOUk","c":"style_c__MLJ1E","icon":"style_icon__Zywap"};